import { Check } from "lucide-react";
import { PLANS } from "../mock";
import { Reveal } from "./Reveal";

export const Pricing = () => (
  <section id="pacchetti" data-testid="pricing-plans-section" className="relative bg-gradient-to-br from-[#7a0a1c] via-[#a50d26] to-[#c8102e] py-16 sm:py-24 overflow-hidden">
    <div className="absolute inset-0 flex items-center">
      <span className="watermark-text text-[20vw] leading-none rotate-2 translate-x-10">Pacchetti</span>
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center max-w-2xl mx-auto">
        <span className="text-[#4caf7d] font-condensed font-bold uppercase tracking-widest text-sm">I pacchetti</span>
        <h2 className="font-condensed font-extrabold uppercase tracking-tight text-white text-3xl sm:text-4xl mt-2">
          Scegli il tuo pacchetto
        </h2>
        <p className="mt-4 text-white/80 text-base sm:text-lg">
          Tre formule pensate per ogni esigenza. Tutte senza vincoli.
        </p>
      </Reveal>
      <div className="mt-14 grid md:grid-cols-3 gap-8 items-stretch max-w-5xl mx-auto">
        {PLANS.map((plan, i) => (
          <Reveal key={plan.id} delay={i * 0.12} className="h-full">
            <div
              data-testid={plan.testid}
              className={`relative h-full bg-white rounded-3xl p-8 flex flex-col shadow-xl transition-all duration-300 hover:-translate-y-1.5 hover:shadow-2xl ${
                plan.highlighted ? "ring-4 ring-[#1b7a46] md:scale-105 z-10" : ""
              }`}
            >
              {plan.highlighted && (
                <span
                  data-testid="plan-badge-plus"
                  className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#1b7a46] text-white font-condensed font-bold uppercase tracking-widest text-xs px-5 py-1.5 rounded-full shadow-md"
                >
                  {plan.badge}
                </span>
              )}
              <h3 className="font-condensed font-extrabold uppercase tracking-tight text-[#191512] text-2xl">
                {plan.name}
              </h3>
              <p className="mt-2 text-slate-500 text-sm min-h-[40px]">{plan.description}</p>
              <div className="mt-4 flex items-end gap-1">
                <span className="font-condensed font-black text-[#c8102e] text-5xl leading-none">{plan.price} €</span>
                <span className="text-slate-500 text-sm mb-1">/mese</span>
              </div>
              <ul className="mt-6 space-y-3 flex-1">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-slate-600">
                    <Check className="w-4 h-4 text-[#1b7a46] mt-0.5 shrink-0" strokeWidth={3} />
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href={plan.paymentLink}
                data-testid={plan.ctaTestid}
                className={`mt-8 w-full text-center font-semibold py-3.5 rounded-full transition-all duration-200 hover:-translate-y-0.5 ${
                  plan.highlighted
                    ? "bg-[#1b7a46] hover:bg-[#0e4a2c] text-white shadow-lg shadow-[#1b7a46]/30"
                    : "bg-[#c8102e] hover:bg-[#a50d26] text-white"
                }`}
              >
                Attiva {plan.name}
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
